import axios from 'axios'

/**
 * 同时校验卡密和 Redis 中的 strongSwan 在线会话。
 * 后端只有在当前卡密存在 VPN 会话时才会返回定位状态。
 */
export async function verifyVpnConnection(session) {
  if (!session || !session.cardKey) {
    throw new Error('卡密已过期，请重新输入')
  }
  const response = await axios.get('/api/vpn/card/location/status', {
    params: {
      cardKey: session.cardKey,
      deviceId: session.deviceId,
      _t: Date.now(),
    },
    timeout: 10000,
  })
  const payload = response && response.data
  if (!payload || payload.code !== 200) {
    throw new Error((payload && payload.msg) || 'VPN 未连接，请先连接 G-lin 独享隧道')
  }
  return payload.data
}

export function vpnAccessErrorMessage(error) {
  const payload = error && error.response && error.response.data
  return (payload && payload.msg) || error.message || 'VPN 未连接，请先连接 G-lin 独享隧道'
}
